import domains from "../data/domains.js";
import subdomains from "../data/subdomains.js";
import paths from "../data/paths.js";
import { toUrl } from "./utils.js";
const cdnDomains = new Map(Object.entries(domains));
const cdnSubdomains = Object.entries(subdomains);
export function getImageCdnForUrl(url) {
  return getImageCdnForUrlByDomain(url) || getImageCdnForUrlByPath(url);
}
export function getImageCdnForUrlByDomain(url) {
  if (typeof url === "string" && !url.startsWith("https://")) {
    return false;
  }
  const {
    hostname
  } = toUrl(url);
  if (cdnDomains.has(hostname)) {
    return cdnDomains.get(hostname);
  }
  for (const [subdomain, cdn] of cdnSubdomains) {
    if (hostname.endsWith("." + subdomain)) {
      return cdn;
    }
  }
  return false;
}
export function getImageCdnForUrlByPath(url) {
  // Allow relative URLs
  const {
    pathname
  } = toUrl(url);
  for (const [prefix, cdn] of Object.entries(paths)) {
    if (pathname.startsWith(prefix)) {
      return cdn;
    }
  }
  return false;
}